const dict = {
  LANGUAGE_LABEL: {
    message: ' Türkce',
  },
  MATRIX_DIMENSIONS_ERROR: {
    message: `Memory puzzle matrix en az 2x2,
    en fazla 10x10 boyutlarinda olmalidir. Örnegin: `,
  },
  LOADING: {
    message: 'Yükleniyor...',
  },
  ENTER_YOUR_NAME: {
    message: 'Isminizi girin',
  },
  PLAYERS_NAME: {
    message: 'Oyuncu adi',
  },
  COLUMNS: {
    message: 'Kolon',
  },
  ROWS: {
    message: 'Sira',
  },
  SELECT_LANGUAGE: {
    message: 'Dil secimi',
  },
  FULL_SCREEN: {
    message: 'Tam ekran',
  },
  APPLY: {
    message: 'Uygula',
  },
  RESTART: {
    message: 'Yeni Oyun',
  },
  PLAY: {
    message: 'Play',
  },
  CONTINUE: {
    message: 'Devam',
  },
  CHALLENGE: {
    message: 'Challenge',
  },
};

export default dict;
